import httpService from './httpService'
import SessionService from './sessionService'

async function purchase(organizationId, paymentPackage, subscribe, useTrial = false) {
  const data = {
    payment_package: paymentPackage,
    subscribe: subscribe,
    useTrial: useTrial,
  }
  return httpService.apiRequest(
    'post',
    `/payment/purchase/${SessionService.getUserUsername()}/organization/${organizationId}`,
    data,
  )
}

/**
 * Buys a minute/text bundle. Without a nonce the card saved on the subscription
 * is charged. `recurring` also adds the bundle to the monthly plan.
 */
async function purchaseExtraMinutes(organizationId, nonce, paymentPackage, recurring = false) {
  const data = {
    payment_method_nonce: nonce,
    payment_package: paymentPackage,
    recurring,
  }
  return httpService.apiRequest(
    'post',
    `/payment/purchase/${SessionService.getUserUsername()}/extraMinutes/${organizationId}`,
    data,
  )
}

async function cancelPurchase(subscriptionId, organization, office) {
  const data = {}
  if (organization) {
    data.organizationId = organization._id
  } else if (office) {
    data.officeId = office._id
    data.office = office
  }
  return httpService.apiRequest(
    'post',
    `/payment/purchase/${SessionService.getUserUsername()}/cancel/${subscriptionId}`,
    data,
  )
}

async function resumePurchase(subscriptionId, organization) {
  return httpService.apiRequest(
    'post',
    `/payment/purchase/${SessionService.getUserUsername()}/resume/${subscriptionId}`,
    { organizationId: organization._id },
  )
}

async function generateToken() {
  return httpService.apiRequest('get', `/payment/client_token/${SessionService.getUserUsername()}`)
}

async function purchaseAddons(organizationId, extensionCount, groupCount) {
  const data = {}
  if (extensionCount !== undefined) data.extensionCount = extensionCount
  if (groupCount !== undefined) data.groupCount = groupCount
  return httpService.apiRequest(
    'post',
    `/payment/purchase/${SessionService.getUserUsername()}/addons/${organizationId}`,
    data,
  )
}

/**
 * Reduces or removes (quantity 0) a recurring bundle from the next renewal.
 */
async function updateRecurringBundle(organizationId, recurringBundleId, quantity) {
  return httpService.apiRequest(
    'post',
    `/payment/purchase/${SessionService.getUserUsername()}/recurringBundles/${organizationId}`,
    { recurringBundleId, quantity },
  )
}

export default {
  purchase,
  purchaseExtraMinutes,
  cancelPurchase,
  resumePurchase,
  generateToken,
  purchaseAddons,
  updateRecurringBundle,
}
